<!-- Operation -->
<div (click)="$event.stopPropagation();" *ngIf="dataType != 'boolean'">
    <!-- Strings -->
    <tyl-form-field (click)="$event.stopPropagation();" [floatLabel]="floatLabel" [ngStyle]="{
            'width': operationSelectWidth,
            'margin-right': operationMarginRight,
            'margin-top': marginTop,
            'margin-bottom': fieldsMarginBottom
        }" *ngIf="dataType == 'string'">

        <mat-select [value]="operation" (valueChange)="operation = $event; filterOperationChange.emit(operation);"
            (click)="$event.stopPropagation()" [attr.id]="columnName + 'FilterOperation'" ariaLabel="Filter Operation"
            tabindex="0">
            <mat-option value="0" [attr.id]="columnName + 'filterOperationOption0'">
                <span translate>Contains</span>
            </mat-option>
            <mat-option value="1" [attr.id]="columnName + 'filterOperationOption1'">
                <span translate>Starts with</span>
            </mat-option>
            <mat-option value="2" [attr.id]="columnName + 'filterOperationOption2'">
                <span translate>Ends with</span>
            </mat-option>
            <mat-option value="3" [attr.id]="columnName + 'filterOperationOption3'">
                <span translate>Equals</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <!-- Numbers or Dates -->
    <tyl-form-field (click)="$event.stopPropagation();" [floatLabel]="floatLabel" [ngStyle]="{
        'width': operationSelectWidth,
        'margin-right': operationMarginRight,
        'margin-top': marginTop,
        'margin-bottom': fieldsMarginBottom
    }" *ngIf="dataType == 'number' || dataType == 'date'">

        <mat-select [value]="operation" (valueChange)="operation = $event; filterOperationChange.emit(operation);"
            (click)="$event.stopPropagation();" [attr.id]="columnName + 'FilterOperation'" ariaLabel="Filter Operation"
            tabindex="0">
            <mat-option value="0" [attr.id]="columnName + 'filterOperationOption0'">
                <span translate>Equals</span>
            </mat-option>
            <mat-option value="1" [attr.id]="columnName + 'filterOperationOption1'">
                <span translate>Not Equal</span>
            </mat-option>
            <mat-option value="2" [attr.id]="columnName + 'filterOperationOption2'">
                <span translate>Less Than</span>
            </mat-option>
            <mat-option value="3" [attr.id]="columnName + 'filterOperationOption3'">
                <span translate>Less Than Or Equal To</span>
            </mat-option>
            <mat-option value="4" [attr.id]="columnName + 'filterOperationOption4'">
                <span translate>Greater Than</span>
            </mat-option>
            <mat-option value="5" [attr.id]="columnName + 'filterOperationOption5'">
                <span translate>Greater Than Or Equal To</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <!-- Enumerations -->
    <tyl-form-field (click)="$event.stopPropagation();" [floatLabel]="floatLabel" [ngStyle]="{
        'width': operationSelectWidth,
        'margin-right': operationMarginRight,
        'margin-top': marginTop,
        'margin-bottom': fieldsMarginBottom
    }" *ngIf="dataType == 'enumeration'">

        <mat-select [value]="operation" (valueChange)="operation = $event; filterOperationChange.emit(operation);"
            (click)="$event.stopPropagation();" [attr.id]="columnName + 'FilterOperation'" ariaLabel="Filter Operation"
            tabindex="0">
            <mat-option value="0" [attr.id]="columnName + 'filterOperationOption0'">
                <span translate>Equals</span>
            </mat-option>
            <mat-option value="1" [attr.id]="columnName + 'filterOperationOption1'">
                <span translate>Not Equal</span>
            </mat-option>
        </mat-select>
    </tyl-form-field>
</div>

<!-- Filter Value -->
<div>
    <!-- Strings and Numbers -->
    <tyl-form-field [label]="showLabel ? 'Filter' : ''" (click)="$event.stopPropagation();" [floatLabel]="floatLabel"
        [ngStyle]="{
            'width': valueWidth,
            'margin-top': marginTop,
            'margin-bottom': fieldsMarginBottom
        }" *ngIf="dataType == 'string' || dataType == 'number'">
        <input matInput [(ngModel)]="filterValue" [attr.id]="columnName + 'FilterInput'" #filterInput
            (input)="filterChange.emit(filterValue)" (keyup.enter)="menuTrigger.emit()"
            [debounce]="debounceTime">
        <button mat-icon-button matSuffix color="warn" (click)="removeClick()"
            [attr.id]="columnName + 'FilterRemoveButton'" *ngIf="filterValue != '' && filterValue != undefined">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
        <button mat-icon-button matSuffix disabled *ngIf="filterValue == '' || filterValue == undefined">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
    </tyl-form-field>

    <!-- Dates -->
    <tyl-datepicker [id]="columnName + 'FilterInput'" (click)="$event.stopPropagation();"
        (dateInputChange)="filterInputRef = $event" [value]="dateValue"
        (valueChange)="dateValue = $event; filterChange.emit(dateValue);" label="mm/dd/yy" [floatLabel]="floatLabel"
        [stopPropagation]="true" [ngStyle]="{
            'width': valueWidth,
            'margin-top': marginTop,
            'margin-bottom': fieldsMarginBottom
        }" [showLabelAsHint]="true" *ngIf="dataType == 'date'">
        <button mat-icon-button matSuffix color="warn" (click)="removeClick()"
            [attr.id]="columnName + 'FilterRemoveButton'"
            *ngIf="dateValue != undefined && dateValue.toString() != 'Invalid Date'">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
        <button mat-icon-button matSuffix disabled
            *ngIf="dateValue == undefined || dateValue.toString() == 'Invalid Date'">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
    </tyl-datepicker>

    <!-- Enumerations -->
    <tyl-form-field [label]="showLabel ? 'Filter' : ''" (click)="$event.stopPropagation();" [floatLabel]="floatLabel"
        [ngStyle]="{
            'width': valueWidth,
            'margin-top': marginTop,
            'margin-bottom': fieldsMarginBottom
        }" *ngIf="dataType == 'enumeration'">
        <mat-select #filterInput [(ngModel)]="filterValue" (click)="$event.stopPropagation()"
            (valueChange)="filterChange.emit(filterValue);" [attr.id]="columnName + 'FilterSelect'"
            placeholder="{{(showLabel ? 'Filter' : '') | translate}}" style="width: 140px" tabindex="0">
            <mat-option *ngFor="let enumerationValue of enumerationValues; let i = index"
                [attr.id]="columnName + 'FilterSelectOption' + i" [value]="enumerationValue">
                {{enumerationValue}}
            </mat-option>
        </mat-select>
        <button mat-icon-button matSuffix color="warn" (click)="removeClick(); $event.stopPropagation();"
            [attr.id]="columnName + 'FilterRemoveButton'" *ngIf="filterValue != '' && filterValue != undefined">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
        <button mat-icon-button matSuffix disabled *ngIf="filterValue == '' || filterValue == undefined">
            <mat-icon>
                <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
            </mat-icon>
        </button>
    </tyl-form-field>

    <!-- Booleans -->
    <div *ngIf="dataType == 'boolean'" (click)="$event.stopPropagation()">
        <tyl-radio-group [values]="['0', '1', '2']" [labels]="[
				'Show all entries',
				showTrueLabel,
				showFalseLabel
			]" [id]="columnName + 'FilterInput'" [ids]="[
				columnName + 'SelectAllRadio',
				columnName + 'SelectTrueRadio',
				columnName + 'SelectFalseRadio'
			]" #filterInput [attr.aria-label]="'Filter'" arrange="vertical" [(selected)]="operation"
            (change)="filterChange.emit(operation); filterOperationChange.emit(operation);"></tyl-radio-group>
    </div>

    <!-- Nullable Booleans -->
    <div *ngIf="dataType == 'nullable boolean'" (click)="$event.stopPropagation()">
        <tyl-radio-group [values]="['0', '1', '2', '3']" [labels]="[
				'Show all entries',
				showTrueLabel,
				showIndeterminateLabel,
				showFalseLabel
			]" [id]="columnName + 'FilterInput'" [ids]="[
				columnName + 'SelectAllRadio',
				columnName + 'SelectTrueRadio',
				columnName + 'SelectIndeterminateRadio',
				columnName + 'SelectFalseRadio'
			]" #filterInput [attr.aria-label]="'Filter'" arrange="vertical" [(selected)]="operation"
            (change)="filterChange.emit(operation); filterOperationChange.emit(operation);"></tyl-radio-group>
    </div>
</div>

